module.exports = __webpack_public_path__ + "static/media/illustration-section-03.7d5cf652.svg";